import type { ListaPrecosQuery, ListaPrecosResponse, PraticadoResponse } from '@triade/contracts';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { ApiError, requisitar } from '@/lib/api';
import { useSessao } from '@/lib/session';
import { useConsulta } from './base';

export type FiltrosLista = Omit<Partial<ListaPrecosQuery>, 'cursor' | 'limit'>;

/** Tamanho da pagina pedida a API (ela calcula so a pagina). */
export const TAMANHO_PAGINA_LISTA = 50;

/** GET /precificacao/lista por cursor: cada pagina e calculada pelo motor sob demanda. */
export function useListaPrecosPaginada(filtros: FiltrosLista) {
  const { empresaId } = useSessao();
  return useInfiniteQuery<ListaPrecosResponse, ApiError, { pages: ListaPrecosResponse[] }, unknown[], string | null>({
    queryKey: ['precificacao', 'lista', empresaId, filtros],
    queryFn: ({ pageParam }) =>
      requisitar<ListaPrecosResponse>('/precificacao/lista', {
        query: { ...filtros, limit: TAMANHO_PAGINA_LISTA, ...(pageParam ? { cursor: pageParam } : {}) },
      }),
    initialPageParam: null,
    getNextPageParam: (ultima) => ultima.nextCursor,
    enabled: empresaId !== null,
    placeholderData: keepPreviousData,
    retry: false,
  });
}

/** GET /precificacao/praticados: historico de um item numa tabela. */
export function useHistoricoPraticados(p: { itemId: string; tabelaId: string; condicaoId?: string } | null) {
  return useConsulta<PraticadoResponse[]>(['precificacao', 'praticados'], '/precificacao/praticados', {
    query: { ...p, limit: 50 },
    ativo: p !== null,
  });
}
